(function () {
  function findWidget() {
    return document.querySelector('#comboBundleContainer, .appstle-combo-bundle');
  }

  function findATCContainer() {
    return document.querySelector('.product-form__buttons')
        || document.querySelector('form[action*="/cart/add"]');
  }

  function moveBundle() {
    var widget = findWidget();
    var atc = findATCContainer();
    if (!widget || !atc || !atc.parentNode) return false;
    if (atc.nextElementSibling === widget) return true;

    atc.parentNode.insertBefore(widget, atc.nextSibling);
    return true;
  }

  function init() {
    moveBundle();
    setTimeout(moveBundle, 500);
    setTimeout(moveBundle, 1500);
    setTimeout(moveBundle, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();